import { SIDEBAR_WIDTH } from 'application/Shared/Constants';
import { createGlobalStyle } from 'styled-components';

export const AppStyles = createGlobalStyle`
    body {
        margin: 0;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        height: 100%;
        @media print {
            min-width: 0;
            background-color: ${(props) =>
                props.theme.palette.background.white};
            height: unset;
            display: block;
            overflow: visible;
        }
    }

    /* Reset legend to default styles from the Boostrap overwrite. We are using legend for Form Arrays */
    legend {
        font-size: unset;
        float: unset;
        width: unset;
        padding: unset;
        margin-bottom: unset;
        font-size: unset;
        line-height: unset;
    }

    .App {
        width: 100%;
        height: 100%;
        background-color: ${(props) => props.theme.palette.background.primary};
        overflow: auto;
    }

    .icon-spin {
        -webkit-animation: icon-spin 2s infinite linear;
        animation: icon-spin 2s infinite linear;
    }

    @-webkit-keyframes icon-spin {
        100% {
            -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
        }
        0% {
            -webkit-transform: rotate(359deg);
            transform: rotate(359deg);
        }
    }

    @keyframes icon-spin {
        100% {
            -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
        }
        0% {
            -webkit-transform: rotate(359deg);
            transform: rotate(359deg);
        }
    }

    #mainViewContainer {
        margin-left: ${SIDEBAR_WIDTH};
        padding: 16px;
        overflow-x: hidden;
        width: 100%;


    }

    #mainViewContainer.noPadding {
        padding: 0;
    }

    .print-only {
        display: none !important;
    }

    .showOnlyInPrint {
        display: none !important;
    }

    .small {
        font-size: 11px;
    }

    .squeezedTable thead tr td {
        padding: 5px 1px;
    }

    .squeezedTable tbody tr td {
        padding: 5px 1px;
    }

    .trialBannerMargin {
        margin-top: 45px; /* magic number, height of viewPricing banner */
    }

    @keyframes spinPause {
        0% {
            transform: rotate(0deg);
        }
        80% {
            transform: rotate(360deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }

    .spin {
        animation: spin 1s linear infinite;
    }

    .dashboard-layout {
        // margin: 0 0 0 -12px;
        // width: calc(100% + 12px);
    }

/* Large screens: 12 columns */
.dashboard-layout.editing.breakpoint-lg {
  background-image:
    repeating-linear-gradient(to right, #CABEFA 0, #CABEFA 1px, transparent 1px, transparent 8.333333333333334%),
    repeating-linear-gradient(to bottom, #B2D0FA 0, #B2D0FA 1px, transparent 1px, transparent 95px);
}

/* Medium screens: 10 columns */
.dashboard-layout.editing.breakpoint-md {
  background-image:
    repeating-linear-gradient(to right, #CABEFA 0, #CABEFA 1px, transparent 1px, transparent 10%),
    repeating-linear-gradient(to bottom, #e0e0e0 0, #e0e0e0 1px, transparent 1px, transparent 60px);
}

/* Small screens: 6 columns */
.dashboard-layout.editing.breakpoint-sm {
  background-image:
    repeating-linear-gradient(to right, #CABEFA 0, #CABEFA 1px, transparent 1px, transparent 16.666666666666668%),
    repeating-linear-gradient(to bottom, #e0e0e0 0, #e0e0e0 1px, transparent 1px, transparent 60px);
}

/* Extra small screens: 2 columns */
.dashboard-layout.editing.breakpoint-xs {
  background-image:
    repeating-linear-gradient(to right, #CABEFA 0, #CABEFA 1px, transparent 1px, transparent 50%),
    repeating-linear-gradient(to bottom, #e0e0e0 0, #e0e0e0 1px, transparent 1px, transparent 60px);
}

/* Extra extra small screens: 1 column */
.dashboard-layout.editing.breakpoint-xxs {
  background-image:
    repeating-linear-gradient(to right, #CABEFA 0, #CABEFA 1px, transparent 1px, transparent 100%),
    repeating-linear-gradient(to bottom, #e0e0e0 0, #e0e0e0 1px, transparent 1px, transparent 60px);
}
`;
